import cx from 'classnames';
import React, { PropsWithChildren } from 'react';

import s from './badge.module.css';

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
    variant:
        | 'success'
        | 'error'
        | 'warning'
        | 'info'
        | 'reverse-success'
        | 'reverse-error'
        | 'reverse-warning'
        | 'reverse-info';
}

const Badge = ({ className, variant, children, ...props }: PropsWithChildren<BadgeProps>) => (
    <div className={cx(s.badge, s[variant], className)} {...props}>
        {children}
    </div>
);

Badge.displayName = 'Badge';

export default Badge;
